export enum TypeScheduleTabsEnum {
    GuiaMedico = 'guia-medico',
    Horario = 'horario',
    TermoDeUso = 'termo-de-uso',
    Confirmacao = 'confirmacao',
    LocalDeExames = 'local-de-exames'
}